import React from 'react'
import classNames from 'classnames'
import StickyWrapper, {
  IProps as StickyWrapperProps,
} from 'Components/new/scroll-sticky/sticky-wrapper'
import usePageOffset from 'Components/hooks/use-page-offset'
import useSideNavStatus from 'Components/hooks/use-side-nav-status'
import { IScrollStickyState } from 'Components/hooks/use-scroll-sticky-observe'
import makePubSubHook from 'Components/hooks/make-pub-sub-hook'

const [setHeaderState, useStickHeader] = makePubSubHook<IScrollStickyState>({
  isFixed: false,
  duration: 0,
})

export { useStickHeader }

interface IProps {
  children: StickyWrapperProps['children']
  markOffset?: number
  className?: string
}

const StickyHeader = ({ children, className }: IProps) => {
  // const { state, setState } = useContext(StickyHeaderContext)
  const state = useStickHeader()
  const { top } = usePageOffset()

  const navStatus = useSideNavStatus()

  return (
    <React.Fragment>
      <StickyWrapper
        className={className}
        outerClassName={(isFixed) =>
          classNames({
            'tw-fixed tw-z-9999 tw-w-full tw-top-0 tw-inset-x-0 tw-m-auto tw-transform tw-translate-x-0':
              isFixed,
          })
        }
        outerStyle={(isFixed) => (isFixed ? { top } : {})}
        innerClassName={(isFixed) =>
          classNames(
            isFixed
              ? {
                  'tw-absolute tw-h-56 lg:tw-h-64 xl:tw-h-78 tw-left-0 tw-right-0 tw-overflow-hidden':
                    true,
                  'tw-left-88 tw-pl-4%': navStatus === 'off',
                  'tw-left-160 tw-pl-4%': navStatus === 'on',
                  'tw-left-88 lg:tw-left-160 tw-pl-4%': navStatus === 'md-off',
                  'tw-left-88 xl:tw-left-160 tw-pl-4%': navStatus === 'lg-off',
                  'lg:tw-left-160 tw-pl-72 lg:tw-pl-4%':
                    navStatus === 'md-none',
                  'tw-pl-72 lg:tw-pl-4%': navStatus === 'none',
                }
              : ''
          )
        }
        innerStyle={(isFixed) => (isFixed ? { paddingRight: '4%' } : {})}
        state={state}
        setState={setHeaderState}
        canListenScroll={({ top }) => top < 0}
        isCurrentFixed={({
          isScrollUp,
          top,
          isIntersecting,
          prevIsIntersecting,
        }) =>
          top < 0 && ((!isIntersecting && prevIsIntersecting) || isScrollUp)
        }
      >
        {children}
      </StickyWrapper>
    </React.Fragment>
  )
}

export default StickyHeader
